export default __webpack_public_path__ + "static/media/profile-pic.d673ef47.jpg";